/* Ekspertium — brand assets oficiales.
   Las imágenes se sirven desde /public/brand/. El isotipo es cuadrado (K
   tipo rayo) y los lockups incluyen el wordmark "ekspertium". */

const ISOTIPO_URL = "/brand/isotipo-512.png";
const LOCKUP_DARK_URL = "/brand/lockup-oscuro.png";   // sobre fondo oscuro (texto blanco)
const LOCKUP_LIGHT_URL = "/brand/lockup-claro.png";   // sobre fondo claro (texto oscuro)


export function LogoMark({ size = 32, className = "" }) {
  return (
    <img
      src={ISOTIPO_URL}
      alt="Ekspertium"
      width={size}
      height={size}
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}

// Wordmark: usamos el lockup oficial (que ya trae isotipo + texto integrados
// con la "k" en color brand). Por eso si el lockup se renderiza en modo
// `withWordmark`, NO acompañamos con LogoMark — el lockup ya lo incluye.
export function LogoWordmark({ className = "", small = false, light = false }) {
  const h = small ? 22 : 28;
  return (
    <img
      src={light ? LOCKUP_DARK_URL : LOCKUP_LIGHT_URL}
      alt="Ekspertium"
      className={`inline-block ${className}`}
      style={{ height: h, width: "auto" }}
      draggable={false}
    />
  );
}

export default function Logo({ size = 32, withWordmark = true, light = false, small = false }) {
  // Si pedimos lockup completo, devolvemos sólo el lockup oficial (el wordmark
  // ya integra el isotipo). Si NO, devolvemos solo el isotipo.
  if (withWordmark) {
    return <LogoWordmark light={light} small={small} />;
  }
  return <LogoMark size={size} />;
}
